import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import style from './UnreadNotice.module.scss';

/** Placement of the dot: large main-nav route buttons vs compact action buttons. */
export type UnreadNoticeVariant = 'route' | 'action';

/**
 * Red notification dot for left-nav buttons, rendered through the item's
 * `element` slot — action buttons and (as of trucktrax-common 1.1.8) route
 * buttons both support it. The default export is bound to unread-messages
 * state; other features connect their own state onto the presentational
 * export (see IncomingMaterialsNotice).
 */
export function UnreadNotice(props: {
  show?: boolean;
  variant?: UnreadNoticeVariant;
  dataTest?: string;
}) {
  const { show, variant = 'action', dataTest = 'unread-notice' } = props;
  if (!show) {
    return null;
  }
  return <span data-test={dataTest} className={cx(style.unreadNotice, style[variant])} />;
}

export default connect((state: any) => ({
  show: !!state.messageList.unreadNotice,
}))(UnreadNotice);
